import { render } from "./wokerDetail8.vue?vue&type=template&id=9d17af6e&scoped=true"
import script from "./wokerDetail8.vue?vue&type=script&lang=js"
export * from "./wokerDetail8.vue?vue&type=script&lang=js"

import "./wokerDetail8.vue?vue&type=style&index=0&id=9d17af6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d17af6e"]])

export default __exports__